import { render, staticRenderFns } from "./EvaluationModel.vue?vue&type=template&id=8aab2fdc&scoped=true&"
import script from "./EvaluationModel.vue?vue&type=script&lang=js&"
export * from "./EvaluationModel.vue?vue&type=script&lang=js&"
import style0 from "./EvaluationModel.vue?vue&type=style&index=0&id=8aab2fdc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aab2fdc",
  null
  
)

component.options.__file = "EvaluationModel.vue"
export default component.exports